export default __webpack_public_path__ + "static/m-from-abroad-two-b6c205133d9639a78f6fd274742ff6f1.jpg";